import React from "react";
import { RouteComponentProps, withRouter } from 'react-router'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../TelemetryService';
import { IUtilityService } from "../../services/UtilityService";
import { Button, Modal, PageHeader } from "antd";


export class PageUtilityComp extends React.Component<RouteComponentProps, any> {

    service: IUtilityService
    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.UTILITY_SERVICE)
    }

    refreshMLModel = async () => {
        Modal.confirm({
            title: "ATTENZONE",
            content: <span> Stai per <b>rigenerare</b> il modello dati di <b>Machine Learning</b> per l'associazione dei movimenti CC in uscita con le categorie di costo.<br /> L'operazione può durare <b>diversi minuti</b>, sicuro di voler procedere?</span>,
            onOk: async () => {
                await this.service.RefreshMLModel();
            }
        })
    }

    render() {
        return (
            <>
                <PageHeader title="Aggiornamento AI per categoria movimenti">
                    <p>Questa funzione permette di rigenerare il modello dati di Machine Learning per l'associazione dei movimenti CC in uscita con le categorie di costo</p>
                    <Button type="primary" onClick={async ()=> await this.refreshMLModel() } >Aggiorna Modello Dati</Button>
                </PageHeader>

            </>
        )
    }
}

export const PageUtility = withRouter(withAITracking(ai.reactPlugin, PageUtilityComp, "PageUtility"))